import getActionsByDocument from '../../../../../components/logs/actions';

const DOCUMENT = 'SECTOR_LOGS_';

export default getActionsByDocument(DOCUMENT);
